import { merge } from "lodash";

import { updatesConfig as baseUpdatesConfig } from "./update-configs/base";
import { updatesConfig as blueprintUpdatesConfig } from "./update-configs/blueprint";
import { updatesConfig as sessionUpdatesConfig } from "./update-configs/session";

export const updatesConfig = merge(
  baseUpdatesConfig,
  blueprintUpdatesConfig,
  sessionUpdatesConfig,
);
